/**
 * <anja-countdown data-start data-end>: campaign state + live countdown.
 * Sets data-state="before|live|ended" on itself; shows [data-anja-timer] before/during, [data-anja-ended]
 * after. Elements with [data-anja-live-only] / [data-anja-before-only] follow the state.
 * Optional [data-anja-hide-outside] on the element hides it entirely outside data-show-from … data-end.
 */
const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

class AnjaCountdown extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.start = Date.parse(this.dataset.start || '');
    this.end = Date.parse(this.dataset.end || '');
    this.showFrom = Date.parse(this.dataset.showFrom || '') || this.start;
    this.tick();
    this.#timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  tick() {
    const now = Date.now();
    const state = !Number.isNaN(this.start) && now < this.start ? 'before' : !Number.isNaN(this.end) && now > this.end ? 'ended' : 'live';
    this.dataset.state = state;

    if (this.hasAttribute('data-anja-hide-outside')) {
      const visible = now >= this.showFrom && (Number.isNaN(this.end) || now <= this.end);
      this.hidden = !visible;
      this.closest('.shopify-section')?.classList.toggle('anja-countdown-hidden', !visible);
    }

    const target = state === 'before' ? this.start : this.end;
    const timer = this.querySelector('[data-anja-timer]');
    const ended = this.querySelector('[data-anja-ended]');
    if (timer instanceof HTMLElement) timer.hidden = state === 'ended' || Number.isNaN(target);
    if (ended instanceof HTMLElement) ended.hidden = state !== 'ended';
    this.querySelectorAll('[data-anja-live-only]').forEach((el) => ((/** @type {HTMLElement} */ (el)).hidden = state !== 'live'));
    this.querySelectorAll('[data-anja-ended-only]').forEach((el) => ((/** @type {HTMLElement} */ (el)).hidden = state !== 'ended'));
    this.querySelectorAll('[data-anja-before-only]').forEach((el) => ((/** @type {HTMLElement} */ (el)).hidden = state !== 'before'));

    const label = this.querySelector('[data-anja-timer-label]');
    if (label instanceof HTMLElement) label.textContent = (state === 'before' ? label.dataset.labelBefore : label.dataset.labelLive) || '';

    if (state === 'ended' || Number.isNaN(target)) {
      clearInterval(this.#timer);
      return;
    }
    let left = Math.max(0, Math.floor((target - now) / 1000));
    const d = Math.floor(left / 86400);
    left -= d * 86400;
    const h = Math.floor(left / 3600);
    left -= h * 3600;
    const m = Math.floor(left / 60);
    const s = left - m * 60;
    const set = (unit, value) => {
      this.querySelectorAll(`[data-unit="${unit}"]`).forEach((el) => (el.textContent = pad(value)));
    };
    set('d', d);
    set('h', h);
    set('m', m);
    set('s', s);
  }
}

if (!customElements.get('anja-countdown')) customElements.define('anja-countdown', AnjaCountdown);
